import { render, staticRenderFns } from "./ContestSwornComponent.vue?vue&type=template&id=751afaf8&scoped=true"
import script from "./ContestSwornComponent.vue?vue&type=script&lang=js"
export * from "./ContestSwornComponent.vue?vue&type=script&lang=js"
import style0 from "./ContestSwornComponent.vue?vue&type=style&index=0&id=751afaf8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "751afaf8",
  null
  
)

export default component.exports